import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Pagination } from "./pagination";
import { Pagamento } from "@/models/pagamento";

const pagamentoPage = require("@/query/pagamento/Page.graphql");
const pagamentoShow = require("@/query/pagamento/Show.graphql");

export class PagamentoAPI extends BaseAPI<Pagamento> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1/payments`;
  }

  public list(params: any): AxiosObservable<Pagination<Pagamento>> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) });
  }

  public listStatus(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/statuses`);
  }

  public show(id: number): AxiosObservable<Pagamento> {
    return this.axios.get(`${this.apiUrl}/${id}`);
  }

  public confirm(id: number, body: any): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/${id}/confirm`, body);
  }
}
